/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actions and reducers used to manipulate application state
import { updateAdsTxtValues } from 'apps/sspadstxt/state/actions/sspmanagerstatus';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import SSPAdsTxt from 'apps/sspadstxt/pages/sspmanager/sspdetail/sspadstxt/sspadstxt';


/* ========== ~~~~~~~~~~ SSP ADSTXT: CHILD ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ sspAdsTxtState }) => {
    const { displayAdsTxtValues, videoAdsTxtValues } = sspAdsTxtState.sspManagerStatus.newSSPDetails;
    const { isEditMode, savingSSPDetails } = sspAdsTxtState.sspManagerStatus;
    return ({
        displayAdsTxtValues,
        videoAdsTxtValues,
        isEditMode,
        savingSSPDetails
    });
};

// map actions
const mapDispatchToProps = dispatch => ({
    updateAdsTxtValues: (values, adType, fileLength) => dispatch(updateAdsTxtValues(values, adType, fileLength))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SSPAdsTxt);
